import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect, useState, type FC } from "react";
import { getListOfferCategory } from "@services/api/offer-category/getList";
import { useLanguage } from "../../../contexts/LanguageContext";
import translations from "./FilterCategory.translations.json";

type SupportedLanguage = keyof typeof translations;

export interface OfferCategory {
  id: number;
  uuid: string | null;
  label: string;
}

interface FilterCategoryProps {
  defaultValue?: number;
  onSubmit: (categoryId: number | undefined) => void;
}

const FilterCategory: FC<FilterCategoryProps> = ({ defaultValue, onSubmit }) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  const [categories, setCategories] = useState<OfferCategory[]>([]);
  const [value, setValue] = useState<number | "">(defaultValue ?? "");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getListOfferCategory();
        setCategories(response?.data || []);
      } catch (error) {
        console.error("Erreur lors de la récupération des catégories :", error);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (newValue: number | "") => {
    setValue(newValue);
    onSubmit(newValue === "" ? undefined : newValue);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 180 }}>
      <Select
        value={value}
        onChange={(e) => handleChange(e.target.value as number | "")}
        displayEmpty
        inputProps={{ "aria-label": content.label }}
        sx={{
          bgcolor: "#121824",
          color: "#fff",
          borderRadius: "8px",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#2a3245" },
          "& .MuiSvgIcon-root": { color: "#fff" },
        }}
      >
        <MenuItem value="">{content.all}</MenuItem>
        {categories.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterCategory;
